import { getMockupsCompareStatsData } from '../../api/analytics3d';
import {createAsyncThunk} from "@reduxjs/toolkit";
import store from "../../store";
import {setNotifications} from "../slices/notifications";

export const getMockupsCompareStats = createAsyncThunk(
    'mockupsCompareStats/getMockupsCompareStats',
    async (queryParams: any, {rejectWithValue}) => {
        try {
            const compareStats = await getMockupsCompareStatsData(queryParams);
            return compareStats;
        } catch (error: any) {
            store.dispatch(setNotifications({text: error.message, type: 'error'}))
            return rejectWithValue(error.message)
        }
    }
); 